import { getGlobals } from "~/utils/get-globals";

export function useGlobals() {
  const globals = getGlobals();

  if (!globals) {
    throw new Error("Global variables have not been defined.");
  }

  return globals;
}
